import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "InControl";

export const getInventoryTypeControl = async (itemType: string) => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetInControlTypes`,
        {},
        {
            ItemType: itemType
        }

    );
};
